/**
 * 运营表「当前语言有确切记录」判据。
 *
 * 两轴模型：语言 Tab 只展示该语言自己的原文，禁止回退 en / zh。
 * Banner 帧已有 language 列；i18n 池仍按该语言 key 非空过滤展示。
 */

export function hasExactI18n(
  i18n: Record<string, string> | null | undefined,
  lang: string,
): boolean {
  return (i18n?.[lang] ?? '').trim().length > 0;
}

export function exactI18nText(
  i18n: Record<string, string> | null | undefined,
  lang: string,
): string {
  return (i18n?.[lang] ?? '').trim();
}
